/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AssignCompaniesInput,
  AvailableCompanyForLinking,
  CombineWithAnotherCompanyResponse,
  Company,
  CompanyApiData,
  CompanyData,
  CompanyIntel,
  CompanyNote,
  CompanyQuoteReportLine,
  CompanyShipmentQuote,
  CompanyShipmentSummary,
  CreateCompanyNoteInput,
  CreateCompanyResponse,
  CreateSalesContactInput,
  CreateSalesContactResponse,
  DashboardUser,
  DeleteCompanyResponse,
  EditCompanyInput,
  EditContactInput,
  EditInvoiceAuditNotesInput,
  HubbleCompaniesServiceGetBranchesResponse,
  HubbleCompaniesServiceUpdateUserHubble,
  IndivualShipmentLine,
  Invitation,
  InvitationUrlResponse,
  ListCompaniesByIdsInput,
  ListCompaniesInput,
  ListCompaniesRow,
  ListSalesContactsRow,
  LogSalesCallInput,
  PaymentMethod,
  ProvisionDashboardUserResponse,
  ResetPasswordUrlResponse,
  SalesContact,
  SavedBroker,
  SavedCommodity,
  SendSalesEmailInput,
  SendSalesEmailResponse,
  SetBookingEngagementOverrideRequest,
  ShipmentReportWithShipment,
  UsersWithQuotedBookedInfo,
} from "../models/index";
import {
  AssignCompaniesInputFromJSON,
  AssignCompaniesInputToJSON,
  AvailableCompanyForLinkingFromJSON,
  AvailableCompanyForLinkingToJSON,
  CombineWithAnotherCompanyResponseFromJSON,
  CombineWithAnotherCompanyResponseToJSON,
  CompanyFromJSON,
  CompanyToJSON,
  CompanyApiDataFromJSON,
  CompanyApiDataToJSON,
  CompanyDataFromJSON,
  CompanyDataToJSON,
  CompanyIntelFromJSON,
  CompanyIntelToJSON,
  CompanyNoteFromJSON,
  CompanyNoteToJSON,
  CompanyQuoteReportLineFromJSON,
  CompanyQuoteReportLineToJSON,
  CompanyShipmentQuoteFromJSON,
  CompanyShipmentQuoteToJSON,
  CompanyShipmentSummaryFromJSON,
  CompanyShipmentSummaryToJSON,
  CreateCompanyNoteInputFromJSON,
  CreateCompanyNoteInputToJSON,
  CreateCompanyResponseFromJSON,
  CreateCompanyResponseToJSON,
  CreateSalesContactInputFromJSON,
  CreateSalesContactInputToJSON,
  CreateSalesContactResponseFromJSON,
  CreateSalesContactResponseToJSON,
  DashboardUserFromJSON,
  DashboardUserToJSON,
  DeleteCompanyResponseFromJSON,
  DeleteCompanyResponseToJSON,
  EditCompanyInputFromJSON,
  EditCompanyInputToJSON,
  EditContactInputFromJSON,
  EditContactInputToJSON,
  EditInvoiceAuditNotesInputFromJSON,
  EditInvoiceAuditNotesInputToJSON,
  HubbleCompaniesServiceGetBranchesResponseFromJSON,
  HubbleCompaniesServiceGetBranchesResponseToJSON,
  HubbleCompaniesServiceUpdateUserHubbleFromJSON,
  HubbleCompaniesServiceUpdateUserHubbleToJSON,
  IndivualShipmentLineFromJSON,
  IndivualShipmentLineToJSON,
  InvitationFromJSON,
  InvitationToJSON,
  InvitationUrlResponseFromJSON,
  InvitationUrlResponseToJSON,
  ListCompaniesByIdsInputFromJSON,
  ListCompaniesByIdsInputToJSON,
  ListCompaniesInputFromJSON,
  ListCompaniesInputToJSON,
  ListCompaniesRowFromJSON,
  ListCompaniesRowToJSON,
  ListSalesContactsRowFromJSON,
  ListSalesContactsRowToJSON,
  LogSalesCallInputFromJSON,
  LogSalesCallInputToJSON,
  PaymentMethodFromJSON,
  PaymentMethodToJSON,
  ProvisionDashboardUserResponseFromJSON,
  ProvisionDashboardUserResponseToJSON,
  ResetPasswordUrlResponseFromJSON,
  ResetPasswordUrlResponseToJSON,
  SalesContactFromJSON,
  SalesContactToJSON,
  SavedBrokerFromJSON,
  SavedBrokerToJSON,
  SavedCommodityFromJSON,
  SavedCommodityToJSON,
  SendSalesEmailInputFromJSON,
  SendSalesEmailInputToJSON,
  SendSalesEmailResponseFromJSON,
  SendSalesEmailResponseToJSON,
  SetBookingEngagementOverrideRequestFromJSON,
  SetBookingEngagementOverrideRequestToJSON,
  ShipmentReportWithShipmentFromJSON,
  ShipmentReportWithShipmentToJSON,
  UsersWithQuotedBookedInfoFromJSON,
  UsersWithQuotedBookedInfoToJSON,
} from "../models/index";

export interface AssignCompaniesRequest {
  assignCompaniesInput: AssignCompaniesInput;
}

export interface AttachUserToCompanyRequest {
  companyId: string;
}

export interface ClearBookingEngagementOverrideRequest {
  companyId: string;
}

export interface ClearSalesCallRequest {
  companyNoteId: string;
}

export interface CombineWithAnotherCompanyRequest {
  originalCompanyId: string;
  destinationCompanyId: string;
}

export interface CompanyQuoteReportRequest {
  companyId: string;
  startDate: string;
  endDate: string;
}

export interface CreateCompanyRequest {
  companyName: string;
}

export interface CreateCompanyNoteRequest {
  createCompanyNoteInput: CreateCompanyNoteInput;
}

export interface CreateCouponRequest {
  companyId: string;
  amount: number;
  purpose: string;
}

export interface CreateSalesContactRequest {
  createSalesContactInput: CreateSalesContactInput;
}

export interface DeleteCompanyRequest {
  companyId: string;
}

export interface DeleteCompanyNoteRequest {
  companyNoteId: string;
}

export interface DeleteSalesContactRequest {
  salesContactId: string;
}

export interface DeleteUserRequest {
  userEmail: string;
}

export interface EditCompanyRequest {
  editCompanyInput: EditCompanyInput;
}

export interface EditContactRequest {
  editContactInput: EditContactInput;
}

export interface EditInvoiceAuditNotesRequest {
  editInvoiceAuditNotesInput: EditInvoiceAuditNotesInput;
}

export interface GetAvailableCompaniesForLinkingRequest {
  companyId: string;
}

export interface GetBookedShipmentsForCompanyRequest {
  companyId: string;
}

export interface GetCompanyRequest {
  companyId: string;
}

export interface GetCompanyApiDataRequest {
  companyId: string;
}

export interface GetCompanyBranchRequest {
  companyId: string;
  userId: string;
}

export interface GetCompanyShipmentSummariesRequest {
  companyId: string;
}

export interface GetCompanyUsersRequest {
  companyId: string;
}

export interface GetDashboardUsersTableDataRequest {
  companyId: string;
}

export interface GetInviteLinkFromHubbleRequest {
  companyId: string;
  invitationToken: string;
}

export interface GetLinkedCompaniesRequest {
  companyId: string;
}

export interface GetPasswordResetLinkForUserFromHubbleRequest {
  userId: string;
  userEmail: string;
  companyId: string;
}

export interface GetSavedBrokersForCompanyRequest {
  companyId: string;
}

export interface GetSavedCommoditiesForCompanyRequest {
  companyId: string;
}

export interface GetShipmentReportsForCompanyRequest {
  companyId: string;
}

export interface LinkCompanyRequest {
  companyId: string;
  linkedCompanyId: string;
}

export interface ListCompaniesRequest {
  listCompaniesInput: ListCompaniesInput;
}

export interface ListCompaniesByIdsRequest {
  listCompaniesByIdsInput: ListCompaniesByIdsInput;
}

export interface ListInvitationsByCompanyRequest {
  companyId: string;
}

export interface ListSalesCallsRequest {
  date: string;
}

export interface ListSalesContactsForCompanyRequest {
  companyId: string;
}

export interface LogSalesCallRequest {
  logSalesCallInput: LogSalesCallInput;
}

export interface MoveSalesContactToDifferentCompanyRequest {
  salesContactId: string;
  newCompanyId: string;
}

export interface MoveUserToDifferentCompanyRequest {
  userEmail: string;
  newCompanyId: string;
}

export interface PreLogSalesCallRequest {
  companyId: string;
  salesContactId: string;
}

export interface ProvisionDashboardUserRequest {
  salesContactId: string;
}

export interface RegenerateCompanyIntelRequest {
  companyId: string;
}

export interface RemoveCreditCardRequest {
  stripeCustomerId: string;
  stripePaymentMethodId: string;
}

export interface RenameCompanyRequest {
  companyId: string;
  newCompanyName: string;
}

export interface ResendInviteFromHubbleRequest {
  companyId: string;
  inviteeEmailAddress: string;
}

export interface RevokeInvitationRequest {
  invitationToken: string;
}

export interface RunCompanyVerificationRequest {
  companyId: string;
}

export interface RunCreditCheckRequest {
  companyId: string;
}

export interface RunSalesIntelligenceRequest {
  companyId: string;
}

export interface SendEmailRequest {
  sendSalesEmailInput: SendSalesEmailInput;
}

export interface SetAccountTypeForCompanyRequest {
  companyId: string;
  isPersonal: boolean;
  isBroker: boolean;
}

export interface SetBookingEngagementOverrideOperationRequest {
  setBookingEngagementOverrideRequest: SetBookingEngagementOverrideRequest;
}

export interface SetCreditTermsForCompanyRequest {
  companyId: string;
  paymentTermsDays: number;
  creditLimitAmount: number;
  doNotAutochargeOverdueInvoices: boolean;
  preferredPaymentMethod: PaymentMethod;
  preferredPaymentMethodNotes?: string | null;
  additionalChargeGracePeriodDaysOverride?: number | null;
}

export interface SetDefaultPaymentMethodRequest {
  companyId: string;
  stripePaymentMethodId: string;
}

export interface SetDiscountAndFixedMarkupRequest {
  companyId: string;
  discountPercentage: number;
  fixedMarkup: number;
}

export interface SetDoNotAutoChargeRequest {
  companyId: string;
  doNotAutocharge: boolean;
}

export interface SetEdiIdRequest {
  companyId: string;
  ediId?: string | null;
}

export interface SetHasNonProfessionalDomainRequest {
  companyId: string;
  hasNonProfessionalDomain: boolean;
}

export interface SetNeedsVerificationRequest {
  companyId: string;
  needsVerification: boolean;
  reason?: string | null;
}

export interface SetPermittedAdditionalPaymentMethodsRequest {
  companyId: string;
  isChequePaymentPermitted: boolean;
  isWirePaymentPermitted: boolean;
  doNotAutochargeOverdueInvoices: boolean;
}

export interface SetQuotingDisabledForCompanyRequest {
  companyId: string;
  quotingDisabled: boolean;
}

export interface SetSalesContactInactiveRequest {
  salesContactId: string;
  inactive: boolean;
}

export interface SetSendReceiptOnLaterPaymentRequest {
  companyId: string;
  sendReceiptOnLaterPayment: boolean;
}

export interface SetVerificationDeniedRequest {
  companyId: string;
  verificationDenied: boolean;
  reason?: string | null;
}

export interface SetXeroContactIdRequest {
  companyId: string;
  xeroContactId: string;
}

export interface SnoozeSalesCallsUntilRequest {
  companyId: string;
  snoozeSalesCallsUntilDate: string;
}

export interface UnlinkCompanyRequest {
  companyId: string;
  linkedCompanyId: string;
}

export interface UpdateCouponPurposeRequest {
  companyId: string;
  couponId: string;
  newPurpose: string;
}

export interface UpdateDashboardUserForCompanyFromHubbleRequest {
  userId: string;
  companyId: string;
  hubbleCompaniesServiceUpdateUserHubble: HubbleCompaniesServiceUpdateUserHubble;
}

export interface UpdateInternalNoteRequest {
  companyNoteId: string;
  createCompanyNoteInput: CreateCompanyNoteInput;
}

export interface UpdateInvitationExpirationDateRequest {
  invitationToken: string;
  expirationDate: string;
}

export interface UpdatePrimaryContactForCompanyRequest {
  companyId: string;
  salesContactId: string;
}

export interface UpdateSalesCallRequest {
  logSalesCallInput: LogSalesCallInput;
}

export interface ViewCompanyDataRequest {
  companyId: string;
}

export interface ViewIndividualShipmentsRequest {
  companyId: string;
  shipmentHash: string;
}

export interface VoidCouponRequest {
  couponId: string;
}

/**
 *
 */
export class CompaniesApi extends runtime.BaseAPI {
  /**
   */
  async assignCompaniesRaw(
    requestParameters: AssignCompaniesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["assignCompaniesInput"] == null) {
      throw new runtime.RequiredError(
        "assignCompaniesInput",
        'Required parameter "assignCompaniesInput" was null or undefined when calling assignCompanies().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/assign-companies`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AssignCompaniesInputToJSON(
          requestParameters["assignCompaniesInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async assignCompanies(
    requestParameters: AssignCompaniesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.assignCompaniesRaw(requestParameters, initOverrides);
  }

  /**
   */
  async attachUserToCompanyRaw(
    requestParameters: AttachUserToCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling attachUserToCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/attach-user-to-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async attachUserToCompany(
    requestParameters: AttachUserToCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.attachUserToCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async clearBookingEngagementOverrideRaw(
    requestParameters: ClearBookingEngagementOverrideRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling clearBookingEngagementOverride().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/clear-booking-engagement-override`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async clearBookingEngagementOverride(
    requestParameters: ClearBookingEngagementOverrideRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.clearBookingEngagementOverrideRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async clearSalesCallRaw(
    requestParameters: ClearSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyNoteId"] == null) {
      throw new runtime.RequiredError(
        "companyNoteId",
        'Required parameter "companyNoteId" was null or undefined when calling clearSalesCall().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyNoteId"] != null) {
      queryParameters["companyNoteId"] = requestParameters["companyNoteId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/clear-sales-call`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async clearSalesCall(
    requestParameters: ClearSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.clearSalesCallRaw(requestParameters, initOverrides);
  }

  /**
   */
  async combineWithAnotherCompanyRaw(
    requestParameters: CombineWithAnotherCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CombineWithAnotherCompanyResponse>> {
    if (requestParameters["originalCompanyId"] == null) {
      throw new runtime.RequiredError(
        "originalCompanyId",
        'Required parameter "originalCompanyId" was null or undefined when calling combineWithAnotherCompany().',
      );
    }

    if (requestParameters["destinationCompanyId"] == null) {
      throw new runtime.RequiredError(
        "destinationCompanyId",
        'Required parameter "destinationCompanyId" was null or undefined when calling combineWithAnotherCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["originalCompanyId"] != null) {
      queryParameters["originalCompanyId"] =
        requestParameters["originalCompanyId"];
    }

    if (requestParameters["destinationCompanyId"] != null) {
      queryParameters["destinationCompanyId"] =
        requestParameters["destinationCompanyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/combine-with-another-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CombineWithAnotherCompanyResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async combineWithAnotherCompany(
    requestParameters: CombineWithAnotherCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CombineWithAnotherCompanyResponse> {
    const response = await this.combineWithAnotherCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async companyQuoteReportRaw(
    requestParameters: CompanyQuoteReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyQuoteReportLine>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling companyQuoteReport().',
      );
    }

    if (requestParameters["startDate"] == null) {
      throw new runtime.RequiredError(
        "startDate",
        'Required parameter "startDate" was null or undefined when calling companyQuoteReport().',
      );
    }

    if (requestParameters["endDate"] == null) {
      throw new runtime.RequiredError(
        "endDate",
        'Required parameter "endDate" was null or undefined when calling companyQuoteReport().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["startDate"] != null) {
      queryParameters["startDate"] = requestParameters["startDate"];
    }

    if (requestParameters["endDate"] != null) {
      queryParameters["endDate"] = requestParameters["endDate"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/company-quote-report`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyQuoteReportLineFromJSON),
    );
  }

  /**
   */
  async companyQuoteReport(
    requestParameters: CompanyQuoteReportRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyQuoteReportLine>> {
    const response = await this.companyQuoteReportRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async createCompanyRaw(
    requestParameters: CreateCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateCompanyResponse>> {
    if (requestParameters["companyName"] == null) {
      throw new runtime.RequiredError(
        "companyName",
        'Required parameter "companyName" was null or undefined when calling createCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyName"] != null) {
      queryParameters["companyName"] = requestParameters["companyName"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/create-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateCompanyResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createCompany(
    requestParameters: CreateCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateCompanyResponse> {
    const response = await this.createCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async createCompanyNoteRaw(
    requestParameters: CreateCompanyNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["createCompanyNoteInput"] == null) {
      throw new runtime.RequiredError(
        "createCompanyNoteInput",
        'Required parameter "createCompanyNoteInput" was null or undefined when calling createCompanyNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/create-company-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCompanyNoteInputToJSON(
          requestParameters["createCompanyNoteInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createCompanyNote(
    requestParameters: CreateCompanyNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createCompanyNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createCouponRaw(
    requestParameters: CreateCouponRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling createCoupon().',
      );
    }

    if (requestParameters["amount"] == null) {
      throw new runtime.RequiredError(
        "amount",
        'Required parameter "amount" was null or undefined when calling createCoupon().',
      );
    }

    if (requestParameters["purpose"] == null) {
      throw new runtime.RequiredError(
        "purpose",
        'Required parameter "purpose" was null or undefined when calling createCoupon().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["amount"] != null) {
      queryParameters["amount"] = requestParameters["amount"];
    }

    if (requestParameters["purpose"] != null) {
      queryParameters["purpose"] = requestParameters["purpose"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/create-coupon`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createCoupon(
    requestParameters: CreateCouponRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createCouponRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createSalesContactRaw(
    requestParameters: CreateSalesContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateSalesContactResponse>> {
    if (requestParameters["createSalesContactInput"] == null) {
      throw new runtime.RequiredError(
        "createSalesContactInput",
        'Required parameter "createSalesContactInput" was null or undefined when calling createSalesContact().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/create-sales-contact`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateSalesContactInputToJSON(
          requestParameters["createSalesContactInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateSalesContactResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createSalesContact(
    requestParameters: CreateSalesContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateSalesContactResponse> {
    const response = await this.createSalesContactRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async deleteCompanyRaw(
    requestParameters: DeleteCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DeleteCompanyResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling deleteCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/delete-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DeleteCompanyResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async deleteCompany(
    requestParameters: DeleteCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DeleteCompanyResponse> {
    const response = await this.deleteCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async deleteCompanyNoteRaw(
    requestParameters: DeleteCompanyNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyNoteId"] == null) {
      throw new runtime.RequiredError(
        "companyNoteId",
        'Required parameter "companyNoteId" was null or undefined when calling deleteCompanyNote().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyNoteId"] != null) {
      queryParameters["companyNoteId"] = requestParameters["companyNoteId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/delete-company-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteCompanyNote(
    requestParameters: DeleteCompanyNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteCompanyNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteSalesContactRaw(
    requestParameters: DeleteSalesContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["salesContactId"] == null) {
      throw new runtime.RequiredError(
        "salesContactId",
        'Required parameter "salesContactId" was null or undefined when calling deleteSalesContact().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["salesContactId"] != null) {
      queryParameters["salesContactId"] = requestParameters["salesContactId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/delete-sales-contact`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteSalesContact(
    requestParameters: DeleteSalesContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteSalesContactRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteUserRaw(
    requestParameters: DeleteUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["userEmail"] == null) {
      throw new runtime.RequiredError(
        "userEmail",
        'Required parameter "userEmail" was null or undefined when calling deleteUser().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["userEmail"] != null) {
      queryParameters["userEmail"] = requestParameters["userEmail"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/delete-user`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteUser(
    requestParameters: DeleteUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteUserRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editCompanyRaw(
    requestParameters: EditCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["editCompanyInput"] == null) {
      throw new runtime.RequiredError(
        "editCompanyInput",
        'Required parameter "editCompanyInput" was null or undefined when calling editCompany().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/edit-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditCompanyInputToJSON(requestParameters["editCompanyInput"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editCompany(
    requestParameters: EditCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editContactRaw(
    requestParameters: EditContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["editContactInput"] == null) {
      throw new runtime.RequiredError(
        "editContactInput",
        'Required parameter "editContactInput" was null or undefined when calling editContact().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/edit-contact`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditContactInputToJSON(requestParameters["editContactInput"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editContact(
    requestParameters: EditContactRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editContactRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editInvoiceAuditNotesRaw(
    requestParameters: EditInvoiceAuditNotesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["editInvoiceAuditNotesInput"] == null) {
      throw new runtime.RequiredError(
        "editInvoiceAuditNotesInput",
        'Required parameter "editInvoiceAuditNotesInput" was null or undefined when calling editInvoiceAuditNotes().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/edit-invoice-audit-notes`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditInvoiceAuditNotesInputToJSON(
          requestParameters["editInvoiceAuditNotesInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editInvoiceAuditNotes(
    requestParameters: EditInvoiceAuditNotesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editInvoiceAuditNotesRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getAvailableCompaniesForLinkingRaw(
    requestParameters: GetAvailableCompaniesForLinkingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<AvailableCompanyForLinking>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getAvailableCompaniesForLinking().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-available-companies-for-linking`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AvailableCompanyForLinkingFromJSON),
    );
  }

  /**
   */
  async getAvailableCompaniesForLinking(
    requestParameters: GetAvailableCompaniesForLinkingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<AvailableCompanyForLinking>> {
    const response = await this.getAvailableCompaniesForLinkingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getBookedShipmentsForCompanyRaw(
    requestParameters: GetBookedShipmentsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyShipmentQuote>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getBookedShipmentsForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-booked-shipments-for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyShipmentQuoteFromJSON),
    );
  }

  /**
   */
  async getBookedShipmentsForCompany(
    requestParameters: GetBookedShipmentsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyShipmentQuote>> {
    const response = await this.getBookedShipmentsForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompanyRaw(
    requestParameters: GetCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Company>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCompany(
    requestParameters: GetCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Company> {
    const response = await this.getCompanyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getCompanyApiDataRaw(
    requestParameters: GetCompanyApiDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyApiData>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompanyApiData().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-company-api-data`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyApiDataFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCompanyApiData(
    requestParameters: GetCompanyApiDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyApiData> {
    const response = await this.getCompanyApiDataRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompanyBranchRaw(
    requestParameters: GetCompanyBranchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HubbleCompaniesServiceGetBranchesResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompanyBranch().',
      );
    }

    if (requestParameters["userId"] == null) {
      throw new runtime.RequiredError(
        "userId",
        'Required parameter "userId" was null or undefined when calling getCompanyBranch().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["userId"] != null) {
      queryParameters["userId"] = requestParameters["userId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-company-branches`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      HubbleCompaniesServiceGetBranchesResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCompanyBranch(
    requestParameters: GetCompanyBranchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HubbleCompaniesServiceGetBranchesResponse> {
    const response = await this.getCompanyBranchRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompanyShipmentSummariesRaw(
    requestParameters: GetCompanyShipmentSummariesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyShipmentSummary>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompanyShipmentSummaries().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/company-shipment-summaries`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyShipmentSummaryFromJSON),
    );
  }

  /**
   */
  async getCompanyShipmentSummaries(
    requestParameters: GetCompanyShipmentSummariesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyShipmentSummary>> {
    const response = await this.getCompanyShipmentSummariesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompanyUsersRaw(
    requestParameters: GetCompanyUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<DashboardUser>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompanyUsers().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-company-users`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(DashboardUserFromJSON),
    );
  }

  /**
   */
  async getCompanyUsers(
    requestParameters: GetCompanyUsersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<DashboardUser>> {
    const response = await this.getCompanyUsersRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getDashboardUsersTableDataRaw(
    requestParameters: GetDashboardUsersTableDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<UsersWithQuotedBookedInfo>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getDashboardUsersTableData().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/dashboard-users-table-data`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(UsersWithQuotedBookedInfoFromJSON),
    );
  }

  /**
   */
  async getDashboardUsersTableData(
    requestParameters: GetDashboardUsersTableDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<UsersWithQuotedBookedInfo>> {
    const response = await this.getDashboardUsersTableDataRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getInviteLinkFromHubbleRaw(
    requestParameters: GetInviteLinkFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InvitationUrlResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getInviteLinkFromHubble().',
      );
    }

    if (requestParameters["invitationToken"] == null) {
      throw new runtime.RequiredError(
        "invitationToken",
        'Required parameter "invitationToken" was null or undefined when calling getInviteLinkFromHubble().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["invitationToken"] != null) {
      queryParameters["invitationToken"] = requestParameters["invitationToken"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-invite-link-from-apollo`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvitationUrlResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getInviteLinkFromHubble(
    requestParameters: GetInviteLinkFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InvitationUrlResponse> {
    const response = await this.getInviteLinkFromHubbleRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getLinkedCompaniesRaw(
    requestParameters: GetLinkedCompaniesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Company>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getLinkedCompanies().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-linked-companies`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyFromJSON),
    );
  }

  /**
   */
  async getLinkedCompanies(
    requestParameters: GetLinkedCompaniesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Company>> {
    const response = await this.getLinkedCompaniesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getPasswordResetLinkForUserFromHubbleRaw(
    requestParameters: GetPasswordResetLinkForUserFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResetPasswordUrlResponse>> {
    if (requestParameters["userId"] == null) {
      throw new runtime.RequiredError(
        "userId",
        'Required parameter "userId" was null or undefined when calling getPasswordResetLinkForUserFromHubble().',
      );
    }

    if (requestParameters["userEmail"] == null) {
      throw new runtime.RequiredError(
        "userEmail",
        'Required parameter "userEmail" was null or undefined when calling getPasswordResetLinkForUserFromHubble().',
      );
    }

    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getPasswordResetLinkForUserFromHubble().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["userId"] != null) {
      queryParameters["userId"] = requestParameters["userId"];
    }

    if (requestParameters["userEmail"] != null) {
      queryParameters["userEmail"] = requestParameters["userEmail"];
    }

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-password-reset-link-for-user-from-apollo`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResetPasswordUrlResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getPasswordResetLinkForUserFromHubble(
    requestParameters: GetPasswordResetLinkForUserFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResetPasswordUrlResponse> {
    const response = await this.getPasswordResetLinkForUserFromHubbleRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getSavedBrokersForCompanyRaw(
    requestParameters: GetSavedBrokersForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SavedBroker>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getSavedBrokersForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-saved-brokers-for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SavedBrokerFromJSON),
    );
  }

  /**
   */
  async getSavedBrokersForCompany(
    requestParameters: GetSavedBrokersForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SavedBroker>> {
    const response = await this.getSavedBrokersForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getSavedCommoditiesForCompanyRaw(
    requestParameters: GetSavedCommoditiesForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SavedCommodity>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getSavedCommoditiesForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-saved-commodities-for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SavedCommodityFromJSON),
    );
  }

  /**
   */
  async getSavedCommoditiesForCompany(
    requestParameters: GetSavedCommoditiesForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SavedCommodity>> {
    const response = await this.getSavedCommoditiesForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getShipmentReportsForCompanyRaw(
    requestParameters: GetShipmentReportsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ShipmentReportWithShipment>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getShipmentReportsForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/get-shipment-reports-for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ShipmentReportWithShipmentFromJSON),
    );
  }

  /**
   */
  async getShipmentReportsForCompany(
    requestParameters: GetShipmentReportsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ShipmentReportWithShipment>> {
    const response = await this.getShipmentReportsForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async linkCompanyRaw(
    requestParameters: LinkCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling linkCompany().',
      );
    }

    if (requestParameters["linkedCompanyId"] == null) {
      throw new runtime.RequiredError(
        "linkedCompanyId",
        'Required parameter "linkedCompanyId" was null or undefined when calling linkCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["linkedCompanyId"] != null) {
      queryParameters["linkedCompanyId"] = requestParameters["linkedCompanyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/link-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async linkCompany(
    requestParameters: LinkCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.linkCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async listAllCompaniesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ListCompaniesRow>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/list-all-companies`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ListCompaniesRowFromJSON),
    );
  }

  /**
   */
  async listAllCompanies(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ListCompaniesRow>> {
    const response = await this.listAllCompaniesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async listCompaniesRaw(
    requestParameters: ListCompaniesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ListCompaniesRow>>> {
    if (requestParameters["listCompaniesInput"] == null) {
      throw new runtime.RequiredError(
        "listCompaniesInput",
        'Required parameter "listCompaniesInput" was null or undefined when calling listCompanies().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/list-companies`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ListCompaniesInputToJSON(requestParameters["listCompaniesInput"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ListCompaniesRowFromJSON),
    );
  }

  /**
   */
  async listCompanies(
    requestParameters: ListCompaniesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ListCompaniesRow>> {
    const response = await this.listCompaniesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listCompaniesByIdsRaw(
    requestParameters: ListCompaniesByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ListCompaniesRow>>> {
    if (requestParameters["listCompaniesByIdsInput"] == null) {
      throw new runtime.RequiredError(
        "listCompaniesByIdsInput",
        'Required parameter "listCompaniesByIdsInput" was null or undefined when calling listCompaniesByIds().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/list-companies-by-ids`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ListCompaniesByIdsInputToJSON(
          requestParameters["listCompaniesByIdsInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ListCompaniesRowFromJSON),
    );
  }

  /**
   */
  async listCompaniesByIds(
    requestParameters: ListCompaniesByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ListCompaniesRow>> {
    const response = await this.listCompaniesByIdsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listInvitationsByCompanyRaw(
    requestParameters: ListInvitationsByCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Invitation>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listInvitationsByCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/list-invitations-by-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(InvitationFromJSON),
    );
  }

  /**
   */
  async listInvitationsByCompany(
    requestParameters: ListInvitationsByCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Invitation>> {
    const response = await this.listInvitationsByCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listSalesCallsRaw(
    requestParameters: ListSalesCallsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyNote>>> {
    if (requestParameters["date"] == null) {
      throw new runtime.RequiredError(
        "date",
        'Required parameter "date" was null or undefined when calling listSalesCalls().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["date"] != null) {
      queryParameters["date"] = requestParameters["date"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/list-sales-calls`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyNoteFromJSON),
    );
  }

  /**
   */
  async listSalesCalls(
    requestParameters: ListSalesCallsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyNote>> {
    const response = await this.listSalesCallsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listSalesContactsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<ListSalesContactsRow>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/list-sales-contacts`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ListSalesContactsRowFromJSON),
    );
  }

  /**
   */
  async listSalesContacts(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<ListSalesContactsRow>> {
    const response = await this.listSalesContactsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async listSalesContactsForCompanyRaw(
    requestParameters: ListSalesContactsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SalesContact>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listSalesContactsForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/list-sales-contacts-for-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SalesContactFromJSON),
    );
  }

  /**
   */
  async listSalesContactsForCompany(
    requestParameters: ListSalesContactsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SalesContact>> {
    const response = await this.listSalesContactsForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async logSalesCallRaw(
    requestParameters: LogSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["logSalesCallInput"] == null) {
      throw new runtime.RequiredError(
        "logSalesCallInput",
        'Required parameter "logSalesCallInput" was null or undefined when calling logSalesCall().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/log-sales-call`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LogSalesCallInputToJSON(requestParameters["logSalesCallInput"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async logSalesCall(
    requestParameters: LogSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.logSalesCallRaw(requestParameters, initOverrides);
  }

  /**
   */
  async moveSalesContactToDifferentCompanyRaw(
    requestParameters: MoveSalesContactToDifferentCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["salesContactId"] == null) {
      throw new runtime.RequiredError(
        "salesContactId",
        'Required parameter "salesContactId" was null or undefined when calling moveSalesContactToDifferentCompany().',
      );
    }

    if (requestParameters["newCompanyId"] == null) {
      throw new runtime.RequiredError(
        "newCompanyId",
        'Required parameter "newCompanyId" was null or undefined when calling moveSalesContactToDifferentCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["salesContactId"] != null) {
      queryParameters["salesContactId"] = requestParameters["salesContactId"];
    }

    if (requestParameters["newCompanyId"] != null) {
      queryParameters["newCompanyId"] = requestParameters["newCompanyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/move-sales-contact-to-different-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async moveSalesContactToDifferentCompany(
    requestParameters: MoveSalesContactToDifferentCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.moveSalesContactToDifferentCompanyRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async moveUserToDifferentCompanyRaw(
    requestParameters: MoveUserToDifferentCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["userEmail"] == null) {
      throw new runtime.RequiredError(
        "userEmail",
        'Required parameter "userEmail" was null or undefined when calling moveUserToDifferentCompany().',
      );
    }

    if (requestParameters["newCompanyId"] == null) {
      throw new runtime.RequiredError(
        "newCompanyId",
        'Required parameter "newCompanyId" was null or undefined when calling moveUserToDifferentCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["userEmail"] != null) {
      queryParameters["userEmail"] = requestParameters["userEmail"];
    }

    if (requestParameters["newCompanyId"] != null) {
      queryParameters["newCompanyId"] = requestParameters["newCompanyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/move-user-to-different-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async moveUserToDifferentCompany(
    requestParameters: MoveUserToDifferentCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.moveUserToDifferentCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async preLogSalesCallRaw(
    requestParameters: PreLogSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling preLogSalesCall().',
      );
    }

    if (requestParameters["salesContactId"] == null) {
      throw new runtime.RequiredError(
        "salesContactId",
        'Required parameter "salesContactId" was null or undefined when calling preLogSalesCall().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["salesContactId"] != null) {
      queryParameters["salesContactId"] = requestParameters["salesContactId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/pre-log-sales-call`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async preLogSalesCall(
    requestParameters: PreLogSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.preLogSalesCallRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async provisionDashboardUserRaw(
    requestParameters: ProvisionDashboardUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ProvisionDashboardUserResponse>> {
    if (requestParameters["salesContactId"] == null) {
      throw new runtime.RequiredError(
        "salesContactId",
        'Required parameter "salesContactId" was null or undefined when calling provisionDashboardUser().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["salesContactId"] != null) {
      queryParameters["salesContactId"] = requestParameters["salesContactId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/provision-dashboard-user`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ProvisionDashboardUserResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async provisionDashboardUser(
    requestParameters: ProvisionDashboardUserRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ProvisionDashboardUserResponse> {
    const response = await this.provisionDashboardUserRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async regenerateCompanyIntelRaw(
    requestParameters: RegenerateCompanyIntelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyIntel>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling regenerateCompanyIntel().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/regenerate-company-intel`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyIntelFromJSON(jsonValue),
    );
  }

  /**
   */
  async regenerateCompanyIntel(
    requestParameters: RegenerateCompanyIntelRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyIntel> {
    const response = await this.regenerateCompanyIntelRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async removeCreditCardRaw(
    requestParameters: RemoveCreditCardRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["stripeCustomerId"] == null) {
      throw new runtime.RequiredError(
        "stripeCustomerId",
        'Required parameter "stripeCustomerId" was null or undefined when calling removeCreditCard().',
      );
    }

    if (requestParameters["stripePaymentMethodId"] == null) {
      throw new runtime.RequiredError(
        "stripePaymentMethodId",
        'Required parameter "stripePaymentMethodId" was null or undefined when calling removeCreditCard().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["stripeCustomerId"] != null) {
      queryParameters["stripeCustomerId"] =
        requestParameters["stripeCustomerId"];
    }

    if (requestParameters["stripePaymentMethodId"] != null) {
      queryParameters["stripePaymentMethodId"] =
        requestParameters["stripePaymentMethodId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/remove-credit-card`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async removeCreditCard(
    requestParameters: RemoveCreditCardRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.removeCreditCardRaw(requestParameters, initOverrides);
  }

  /**
   */
  async renameCompanyRaw(
    requestParameters: RenameCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling renameCompany().',
      );
    }

    if (requestParameters["newCompanyName"] == null) {
      throw new runtime.RequiredError(
        "newCompanyName",
        'Required parameter "newCompanyName" was null or undefined when calling renameCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["newCompanyName"] != null) {
      queryParameters["newCompanyName"] = requestParameters["newCompanyName"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/rename-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async renameCompany(
    requestParameters: RenameCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.renameCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async resendInviteFromHubbleRaw(
    requestParameters: ResendInviteFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InvitationUrlResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling resendInviteFromHubble().',
      );
    }

    if (requestParameters["inviteeEmailAddress"] == null) {
      throw new runtime.RequiredError(
        "inviteeEmailAddress",
        'Required parameter "inviteeEmailAddress" was null or undefined when calling resendInviteFromHubble().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["inviteeEmailAddress"] != null) {
      queryParameters["inviteeEmailAddress"] =
        requestParameters["inviteeEmailAddress"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/resend-invite-from-apollo`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InvitationUrlResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async resendInviteFromHubble(
    requestParameters: ResendInviteFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InvitationUrlResponse> {
    const response = await this.resendInviteFromHubbleRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async revokeInvitationRaw(
    requestParameters: RevokeInvitationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["invitationToken"] == null) {
      throw new runtime.RequiredError(
        "invitationToken",
        'Required parameter "invitationToken" was null or undefined when calling revokeInvitation().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["invitationToken"] != null) {
      queryParameters["invitationToken"] = requestParameters["invitationToken"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/revoke-invitation`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async revokeInvitation(
    requestParameters: RevokeInvitationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.revokeInvitationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async runCompanyVerificationRaw(
    requestParameters: RunCompanyVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling runCompanyVerification().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/run-company-verification`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async runCompanyVerification(
    requestParameters: RunCompanyVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.runCompanyVerificationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async runCreditCheckRaw(
    requestParameters: RunCreditCheckRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling runCreditCheck().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/run-credit-check`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async runCreditCheck(
    requestParameters: RunCreditCheckRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.runCreditCheckRaw(requestParameters, initOverrides);
  }

  /**
   */
  async runSalesIntelligenceRaw(
    requestParameters: RunSalesIntelligenceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling runSalesIntelligence().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/run-sales-intelligence`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async runSalesIntelligence(
    requestParameters: RunSalesIntelligenceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.runSalesIntelligenceRaw(requestParameters, initOverrides);
  }

  /**
   */
  async sendEmailRaw(
    requestParameters: SendEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SendSalesEmailResponse>> {
    if (requestParameters["sendSalesEmailInput"] == null) {
      throw new runtime.RequiredError(
        "sendSalesEmailInput",
        'Required parameter "sendSalesEmailInput" was null or undefined when calling sendEmail().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/send-email`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SendSalesEmailInputToJSON(
          requestParameters["sendSalesEmailInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SendSalesEmailResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async sendEmail(
    requestParameters: SendEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SendSalesEmailResponse> {
    const response = await this.sendEmailRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async setAccountTypeForCompanyRaw(
    requestParameters: SetAccountTypeForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setAccountTypeForCompany().',
      );
    }

    if (requestParameters["isPersonal"] == null) {
      throw new runtime.RequiredError(
        "isPersonal",
        'Required parameter "isPersonal" was null or undefined when calling setAccountTypeForCompany().',
      );
    }

    if (requestParameters["isBroker"] == null) {
      throw new runtime.RequiredError(
        "isBroker",
        'Required parameter "isBroker" was null or undefined when calling setAccountTypeForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["isPersonal"] != null) {
      queryParameters["isPersonal"] = requestParameters["isPersonal"];
    }

    if (requestParameters["isBroker"] != null) {
      queryParameters["isBroker"] = requestParameters["isBroker"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-account-type-for-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setAccountTypeForCompany(
    requestParameters: SetAccountTypeForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setAccountTypeForCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setBookingEngagementOverrideRaw(
    requestParameters: SetBookingEngagementOverrideOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["setBookingEngagementOverrideRequest"] == null) {
      throw new runtime.RequiredError(
        "setBookingEngagementOverrideRequest",
        'Required parameter "setBookingEngagementOverrideRequest" was null or undefined when calling setBookingEngagementOverride().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/set-booking-engagement-override`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetBookingEngagementOverrideRequestToJSON(
          requestParameters["setBookingEngagementOverrideRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setBookingEngagementOverride(
    requestParameters: SetBookingEngagementOverrideOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setBookingEngagementOverrideRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setCreditTermsForCompanyRaw(
    requestParameters: SetCreditTermsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setCreditTermsForCompany().',
      );
    }

    if (requestParameters["paymentTermsDays"] == null) {
      throw new runtime.RequiredError(
        "paymentTermsDays",
        'Required parameter "paymentTermsDays" was null or undefined when calling setCreditTermsForCompany().',
      );
    }

    if (requestParameters["creditLimitAmount"] == null) {
      throw new runtime.RequiredError(
        "creditLimitAmount",
        'Required parameter "creditLimitAmount" was null or undefined when calling setCreditTermsForCompany().',
      );
    }

    if (requestParameters["doNotAutochargeOverdueInvoices"] == null) {
      throw new runtime.RequiredError(
        "doNotAutochargeOverdueInvoices",
        'Required parameter "doNotAutochargeOverdueInvoices" was null or undefined when calling setCreditTermsForCompany().',
      );
    }

    if (requestParameters["preferredPaymentMethod"] == null) {
      throw new runtime.RequiredError(
        "preferredPaymentMethod",
        'Required parameter "preferredPaymentMethod" was null or undefined when calling setCreditTermsForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["paymentTermsDays"] != null) {
      queryParameters["paymentTermsDays"] =
        requestParameters["paymentTermsDays"];
    }

    if (requestParameters["creditLimitAmount"] != null) {
      queryParameters["creditLimitAmount"] =
        requestParameters["creditLimitAmount"];
    }

    if (requestParameters["doNotAutochargeOverdueInvoices"] != null) {
      queryParameters["doNotAutochargeOverdueInvoices"] =
        requestParameters["doNotAutochargeOverdueInvoices"];
    }

    if (requestParameters["preferredPaymentMethod"] != null) {
      queryParameters["preferredPaymentMethod"] =
        requestParameters["preferredPaymentMethod"];
    }

    if (requestParameters["preferredPaymentMethodNotes"] != null) {
      queryParameters["preferredPaymentMethodNotes"] =
        requestParameters["preferredPaymentMethodNotes"];
    }

    if (requestParameters["additionalChargeGracePeriodDaysOverride"] != null) {
      queryParameters["additionalChargeGracePeriodDaysOverride"] =
        requestParameters["additionalChargeGracePeriodDaysOverride"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-credit-terms-for-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCreditTermsForCompany(
    requestParameters: SetCreditTermsForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCreditTermsForCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setDefaultPaymentMethodRaw(
    requestParameters: SetDefaultPaymentMethodRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setDefaultPaymentMethod().',
      );
    }

    if (requestParameters["stripePaymentMethodId"] == null) {
      throw new runtime.RequiredError(
        "stripePaymentMethodId",
        'Required parameter "stripePaymentMethodId" was null or undefined when calling setDefaultPaymentMethod().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["stripePaymentMethodId"] != null) {
      queryParameters["stripePaymentMethodId"] =
        requestParameters["stripePaymentMethodId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-default-payment-method`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setDefaultPaymentMethod(
    requestParameters: SetDefaultPaymentMethodRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setDefaultPaymentMethodRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setDiscountAndFixedMarkupRaw(
    requestParameters: SetDiscountAndFixedMarkupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setDiscountAndFixedMarkup().',
      );
    }

    if (requestParameters["discountPercentage"] == null) {
      throw new runtime.RequiredError(
        "discountPercentage",
        'Required parameter "discountPercentage" was null or undefined when calling setDiscountAndFixedMarkup().',
      );
    }

    if (requestParameters["fixedMarkup"] == null) {
      throw new runtime.RequiredError(
        "fixedMarkup",
        'Required parameter "fixedMarkup" was null or undefined when calling setDiscountAndFixedMarkup().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["discountPercentage"] != null) {
      queryParameters["discountPercentage"] =
        requestParameters["discountPercentage"];
    }

    if (requestParameters["fixedMarkup"] != null) {
      queryParameters["fixedMarkup"] = requestParameters["fixedMarkup"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-discount-and-fixed-markup`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setDiscountAndFixedMarkup(
    requestParameters: SetDiscountAndFixedMarkupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setDiscountAndFixedMarkupRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setDoNotAutoChargeRaw(
    requestParameters: SetDoNotAutoChargeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setDoNotAutoCharge().',
      );
    }

    if (requestParameters["doNotAutocharge"] == null) {
      throw new runtime.RequiredError(
        "doNotAutocharge",
        'Required parameter "doNotAutocharge" was null or undefined when calling setDoNotAutoCharge().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["doNotAutocharge"] != null) {
      queryParameters["doNotAutocharge"] = requestParameters["doNotAutocharge"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-do-not-autocharge`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setDoNotAutoCharge(
    requestParameters: SetDoNotAutoChargeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setDoNotAutoChargeRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setEdiIdRaw(
    requestParameters: SetEdiIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setEdiId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["ediId"] != null) {
      queryParameters["ediId"] = requestParameters["ediId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-edi-id`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setEdiId(
    requestParameters: SetEdiIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setEdiIdRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setHasNonProfessionalDomainRaw(
    requestParameters: SetHasNonProfessionalDomainRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setHasNonProfessionalDomain().',
      );
    }

    if (requestParameters["hasNonProfessionalDomain"] == null) {
      throw new runtime.RequiredError(
        "hasNonProfessionalDomain",
        'Required parameter "hasNonProfessionalDomain" was null or undefined when calling setHasNonProfessionalDomain().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["hasNonProfessionalDomain"] != null) {
      queryParameters["hasNonProfessionalDomain"] =
        requestParameters["hasNonProfessionalDomain"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-has-non-professional-domain`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setHasNonProfessionalDomain(
    requestParameters: SetHasNonProfessionalDomainRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setHasNonProfessionalDomainRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setNeedsVerificationRaw(
    requestParameters: SetNeedsVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setNeedsVerification().',
      );
    }

    if (requestParameters["needsVerification"] == null) {
      throw new runtime.RequiredError(
        "needsVerification",
        'Required parameter "needsVerification" was null or undefined when calling setNeedsVerification().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["needsVerification"] != null) {
      queryParameters["needsVerification"] =
        requestParameters["needsVerification"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-needs-verification`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setNeedsVerification(
    requestParameters: SetNeedsVerificationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setNeedsVerificationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setPermittedAdditionalPaymentMethodsRaw(
    requestParameters: SetPermittedAdditionalPaymentMethodsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setPermittedAdditionalPaymentMethods().',
      );
    }

    if (requestParameters["isChequePaymentPermitted"] == null) {
      throw new runtime.RequiredError(
        "isChequePaymentPermitted",
        'Required parameter "isChequePaymentPermitted" was null or undefined when calling setPermittedAdditionalPaymentMethods().',
      );
    }

    if (requestParameters["isWirePaymentPermitted"] == null) {
      throw new runtime.RequiredError(
        "isWirePaymentPermitted",
        'Required parameter "isWirePaymentPermitted" was null or undefined when calling setPermittedAdditionalPaymentMethods().',
      );
    }

    if (requestParameters["doNotAutochargeOverdueInvoices"] == null) {
      throw new runtime.RequiredError(
        "doNotAutochargeOverdueInvoices",
        'Required parameter "doNotAutochargeOverdueInvoices" was null or undefined when calling setPermittedAdditionalPaymentMethods().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["isChequePaymentPermitted"] != null) {
      queryParameters["isChequePaymentPermitted"] =
        requestParameters["isChequePaymentPermitted"];
    }

    if (requestParameters["isWirePaymentPermitted"] != null) {
      queryParameters["isWirePaymentPermitted"] =
        requestParameters["isWirePaymentPermitted"];
    }

    if (requestParameters["doNotAutochargeOverdueInvoices"] != null) {
      queryParameters["doNotAutochargeOverdueInvoices"] =
        requestParameters["doNotAutochargeOverdueInvoices"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-permitted-additional-payment-methods`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setPermittedAdditionalPaymentMethods(
    requestParameters: SetPermittedAdditionalPaymentMethodsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setPermittedAdditionalPaymentMethodsRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setQuotingDisabledForCompanyRaw(
    requestParameters: SetQuotingDisabledForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setQuotingDisabledForCompany().',
      );
    }

    if (requestParameters["quotingDisabled"] == null) {
      throw new runtime.RequiredError(
        "quotingDisabled",
        'Required parameter "quotingDisabled" was null or undefined when calling setQuotingDisabledForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["quotingDisabled"] != null) {
      queryParameters["quotingDisabled"] = requestParameters["quotingDisabled"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-quoting-disabled-for-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setQuotingDisabledForCompany(
    requestParameters: SetQuotingDisabledForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setQuotingDisabledForCompanyRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setSalesContactInactiveRaw(
    requestParameters: SetSalesContactInactiveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["salesContactId"] == null) {
      throw new runtime.RequiredError(
        "salesContactId",
        'Required parameter "salesContactId" was null or undefined when calling setSalesContactInactive().',
      );
    }

    if (requestParameters["inactive"] == null) {
      throw new runtime.RequiredError(
        "inactive",
        'Required parameter "inactive" was null or undefined when calling setSalesContactInactive().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["salesContactId"] != null) {
      queryParameters["salesContactId"] = requestParameters["salesContactId"];
    }

    if (requestParameters["inactive"] != null) {
      queryParameters["inactive"] = requestParameters["inactive"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-sales-contact-inactive`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setSalesContactInactive(
    requestParameters: SetSalesContactInactiveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setSalesContactInactiveRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setSendReceiptOnLaterPaymentRaw(
    requestParameters: SetSendReceiptOnLaterPaymentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setSendReceiptOnLaterPayment().',
      );
    }

    if (requestParameters["sendReceiptOnLaterPayment"] == null) {
      throw new runtime.RequiredError(
        "sendReceiptOnLaterPayment",
        'Required parameter "sendReceiptOnLaterPayment" was null or undefined when calling setSendReceiptOnLaterPayment().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["sendReceiptOnLaterPayment"] != null) {
      queryParameters["sendReceiptOnLaterPayment"] =
        requestParameters["sendReceiptOnLaterPayment"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-send-receipt-on-later-payment`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setSendReceiptOnLaterPayment(
    requestParameters: SetSendReceiptOnLaterPaymentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setSendReceiptOnLaterPaymentRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setVerificationDeniedRaw(
    requestParameters: SetVerificationDeniedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setVerificationDenied().',
      );
    }

    if (requestParameters["verificationDenied"] == null) {
      throw new runtime.RequiredError(
        "verificationDenied",
        'Required parameter "verificationDenied" was null or undefined when calling setVerificationDenied().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["verificationDenied"] != null) {
      queryParameters["verificationDenied"] =
        requestParameters["verificationDenied"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-verification-denied`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setVerificationDenied(
    requestParameters: SetVerificationDeniedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setVerificationDeniedRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setXeroContactIdRaw(
    requestParameters: SetXeroContactIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling setXeroContactId().',
      );
    }

    if (requestParameters["xeroContactId"] == null) {
      throw new runtime.RequiredError(
        "xeroContactId",
        'Required parameter "xeroContactId" was null or undefined when calling setXeroContactId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["xeroContactId"] != null) {
      queryParameters["xeroContactId"] = requestParameters["xeroContactId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/set-xero-contact-id`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setXeroContactId(
    requestParameters: SetXeroContactIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setXeroContactIdRaw(requestParameters, initOverrides);
  }

  /**
   */
  async snoozeSalesCallsUntilRaw(
    requestParameters: SnoozeSalesCallsUntilRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling snoozeSalesCallsUntil().',
      );
    }

    if (requestParameters["snoozeSalesCallsUntilDate"] == null) {
      throw new runtime.RequiredError(
        "snoozeSalesCallsUntilDate",
        'Required parameter "snoozeSalesCallsUntilDate" was null or undefined when calling snoozeSalesCallsUntil().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["snoozeSalesCallsUntilDate"] != null) {
      queryParameters["snoozeSalesCallsUntilDate"] =
        requestParameters["snoozeSalesCallsUntilDate"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/snooze-sales-calls-until`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async snoozeSalesCallsUntil(
    requestParameters: SnoozeSalesCallsUntilRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.snoozeSalesCallsUntilRaw(requestParameters, initOverrides);
  }

  /**
   */
  async unlinkCompanyRaw(
    requestParameters: UnlinkCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling unlinkCompany().',
      );
    }

    if (requestParameters["linkedCompanyId"] == null) {
      throw new runtime.RequiredError(
        "linkedCompanyId",
        'Required parameter "linkedCompanyId" was null or undefined when calling unlinkCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["linkedCompanyId"] != null) {
      queryParameters["linkedCompanyId"] = requestParameters["linkedCompanyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/unlink-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async unlinkCompany(
    requestParameters: UnlinkCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.unlinkCompanyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateCouponPurposeRaw(
    requestParameters: UpdateCouponPurposeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling updateCouponPurpose().',
      );
    }

    if (requestParameters["couponId"] == null) {
      throw new runtime.RequiredError(
        "couponId",
        'Required parameter "couponId" was null or undefined when calling updateCouponPurpose().',
      );
    }

    if (requestParameters["newPurpose"] == null) {
      throw new runtime.RequiredError(
        "newPurpose",
        'Required parameter "newPurpose" was null or undefined when calling updateCouponPurpose().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["couponId"] != null) {
      queryParameters["couponId"] = requestParameters["couponId"];
    }

    if (requestParameters["newPurpose"] != null) {
      queryParameters["newPurpose"] = requestParameters["newPurpose"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/update-coupon-purpose`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateCouponPurpose(
    requestParameters: UpdateCouponPurposeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateCouponPurposeRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateDashboardUserForCompanyFromHubbleRaw(
    requestParameters: UpdateDashboardUserForCompanyFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["userId"] == null) {
      throw new runtime.RequiredError(
        "userId",
        'Required parameter "userId" was null or undefined when calling updateDashboardUserForCompanyFromHubble().',
      );
    }

    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling updateDashboardUserForCompanyFromHubble().',
      );
    }

    if (requestParameters["hubbleCompaniesServiceUpdateUserHubble"] == null) {
      throw new runtime.RequiredError(
        "hubbleCompaniesServiceUpdateUserHubble",
        'Required parameter "hubbleCompaniesServiceUpdateUserHubble" was null or undefined when calling updateDashboardUserForCompanyFromHubble().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["userId"] != null) {
      queryParameters["userId"] = requestParameters["userId"];
    }

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/update-dashboard-user-for-company-from-apollo`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleCompaniesServiceUpdateUserHubbleToJSON(
          requestParameters["hubbleCompaniesServiceUpdateUserHubble"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateDashboardUserForCompanyFromHubble(
    requestParameters: UpdateDashboardUserForCompanyFromHubbleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateDashboardUserForCompanyFromHubbleRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async updateInternalNoteRaw(
    requestParameters: UpdateInternalNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyNoteId"] == null) {
      throw new runtime.RequiredError(
        "companyNoteId",
        'Required parameter "companyNoteId" was null or undefined when calling updateInternalNote().',
      );
    }

    if (requestParameters["createCompanyNoteInput"] == null) {
      throw new runtime.RequiredError(
        "createCompanyNoteInput",
        'Required parameter "createCompanyNoteInput" was null or undefined when calling updateInternalNote().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyNoteId"] != null) {
      queryParameters["companyNoteId"] = requestParameters["companyNoteId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/update-internal-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateCompanyNoteInputToJSON(
          requestParameters["createCompanyNoteInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateInternalNote(
    requestParameters: UpdateInternalNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateInternalNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateInvitationExpirationDateRaw(
    requestParameters: UpdateInvitationExpirationDateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["invitationToken"] == null) {
      throw new runtime.RequiredError(
        "invitationToken",
        'Required parameter "invitationToken" was null or undefined when calling updateInvitationExpirationDate().',
      );
    }

    if (requestParameters["expirationDate"] == null) {
      throw new runtime.RequiredError(
        "expirationDate",
        'Required parameter "expirationDate" was null or undefined when calling updateInvitationExpirationDate().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["invitationToken"] != null) {
      queryParameters["invitationToken"] = requestParameters["invitationToken"];
    }

    if (requestParameters["expirationDate"] != null) {
      queryParameters["expirationDate"] = requestParameters["expirationDate"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/update-invitation-expiration-date`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateInvitationExpirationDate(
    requestParameters: UpdateInvitationExpirationDateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateInvitationExpirationDateRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async updatePrimaryContactForCompanyRaw(
    requestParameters: UpdatePrimaryContactForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling updatePrimaryContactForCompany().',
      );
    }

    if (requestParameters["salesContactId"] == null) {
      throw new runtime.RequiredError(
        "salesContactId",
        'Required parameter "salesContactId" was null or undefined when calling updatePrimaryContactForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["salesContactId"] != null) {
      queryParameters["salesContactId"] = requestParameters["salesContactId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/update-primary-contact-for-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updatePrimaryContactForCompany(
    requestParameters: UpdatePrimaryContactForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updatePrimaryContactForCompanyRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async updateSalesCallRaw(
    requestParameters: UpdateSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["logSalesCallInput"] == null) {
      throw new runtime.RequiredError(
        "logSalesCallInput",
        'Required parameter "logSalesCallInput" was null or undefined when calling updateSalesCall().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/companies/update-sales-call`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: LogSalesCallInputToJSON(requestParameters["logSalesCallInput"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateSalesCall(
    requestParameters: UpdateSalesCallRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateSalesCallRaw(requestParameters, initOverrides);
  }

  /**
   */
  async viewCompanyDataRaw(
    requestParameters: ViewCompanyDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyData>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling viewCompanyData().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/view-company-data`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyDataFromJSON(jsonValue),
    );
  }

  /**
   */
  async viewCompanyData(
    requestParameters: ViewCompanyDataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyData> {
    const response = await this.viewCompanyDataRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async viewIndividualShipmentsRaw(
    requestParameters: ViewIndividualShipmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<IndivualShipmentLine>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling viewIndividualShipments().',
      );
    }

    if (requestParameters["shipmentHash"] == null) {
      throw new runtime.RequiredError(
        "shipmentHash",
        'Required parameter "shipmentHash" was null or undefined when calling viewIndividualShipments().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["shipmentHash"] != null) {
      queryParameters["shipmentHash"] = requestParameters["shipmentHash"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/view-individual-shipments`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(IndivualShipmentLineFromJSON),
    );
  }

  /**
   */
  async viewIndividualShipments(
    requestParameters: ViewIndividualShipmentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<IndivualShipmentLine>> {
    const response = await this.viewIndividualShipmentsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async voidCouponRaw(
    requestParameters: VoidCouponRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["couponId"] == null) {
      throw new runtime.RequiredError(
        "couponId",
        'Required parameter "couponId" was null or undefined when calling voidCoupon().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["couponId"] != null) {
      queryParameters["couponId"] = requestParameters["couponId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/companies/void-coupon`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async voidCoupon(
    requestParameters: VoidCouponRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.voidCouponRaw(requestParameters, initOverrides);
  }
}
